// extracted by mini-css-extract-plugin
export default {"SchoolPage":"styles_SchoolPage__dug1d","iframe":"styles_iframe__Pnm3j"};